import axios from "axios";
import apiUrl from "../../ApiUrl";
import HoldOn from "react-hold-on";
import {
  loginSuccess,
  logOut,
  setSessionValid,
  setStudentId,
  setUserDetails,
  setUserPhoneNo,
  setUserStatus,
} from "../../Reducer/Config";
import { getUserDetail } from "../UserAction";
import toast from "react-hot-toast";

export const login = (body, setStep) => async (dispatch) => {
  let options = {
    theme: "sk-cube-grid",
    message: "Validating credentials...",
  };
  try {
    HoldOn.open(options);
    const response = await axios.post(`${apiUrl}auth/login`, body);
    if (response.data) {
      toast.promise(
        Promise.resolve(response.data), // Using the response data directly instead of undefined saveSettings
        {
          loading: "Sending OTP...",
          success: <b>OTP sent successfully!</b>,
          error: <b>Could not send OTP.</b>,
        }
      );
      dispatch(loginSuccess(response.data));
      setStep(2);
    }
  } catch (error) {
    console.error("Error in Login API:", error);
  } finally {
    HoldOn.close();
  }
};

export const confirmLogin =
  (body, navigate, destination) => async (dispatch) => {
    console.log("destination:", destination);
    let options = {
      theme: "sk-cube-grid",
      message: "Validating OTP...",
    };
    try {
      HoldOn.open(options);
      const response = await axios.post(`${apiUrl}auth/verifyOTP`, body, {
        withCredentials: true,
      });
      if (response.data) {
        const { accessToken, user_id, phone_number, status } = response.data;
        // sessionStorage.setItem("accessToken", accessToken);
        toast.promise(Promise.resolve(response.data), {
          loading: "Verifying OTP...",
          success: <b>OTP verified successfully!</b>,
          error: <b>Could not verify OTP.</b>,
        });
        dispatch(setUserPhoneNo(phone_number));
        dispatch(getUserDetail(user_id));
        dispatch(setStudentId(user_id));
        dispatch(setUserStatus(status));

        // Check session after OTP verification
        const sessionResponse = await fetch(`${apiUrl}session`, {
          method: "GET",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        const sessionResult = await sessionResponse.json();

        if (sessionResult.valid) {
          dispatch(setSessionValid(true));
          // Navigate to dashboard only if session is valid
          if (!destination) {
            navigate("/dashboard");
          }
        } else {
          dispatch(setSessionValid(false));
          dispatch(logOut());
        }
      }
    } catch (error) {
      console.error("Error in Confirm Login:", error);
      dispatch(setSessionValid(false));
    } finally {
      HoldOn.close();
    }
  };

// Session Check Action
export const checkSession = () => async (dispatch) => {
  try {
    const requestOptions = {
      method: "GET",
      credentials: "include", // This enables sending cookies
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const response = await fetch(`${apiUrl}session`, requestOptions);
    const result = await response.json();
    console.log(result);

    if (result.valid) {
      dispatch(setSessionValid(true));
      console.log("session is valid");
    } else {
      dispatch(setSessionValid(false));
      dispatch(logOut());
      console.log("session is not valid");
    }
  } catch (error) {
    console.error("Error checking session:", error);
    dispatch(setSessionValid(false));
    dispatch(logOut());
  }
};

export const logout = () => async (dispatch) => {
  try {
    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    await fetch(`${apiUrl}logout`, requestOptions);
    await dispatch(checkSession());
  } catch (error) {
    console.error("Error logging out:", error);
  }
};
